import { render, staticRenderFns } from "./NewCompanyPage.vue?vue&type=template&id=327e2bab&scoped=true"
import script from "./NewCompanyPage.vue?vue&type=script&lang=js"
export * from "./NewCompanyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e2bab",
  null
  
)

export default component.exports